/**
 * How many unresolved words each get a hint letter in play (crossword: middle cell; grid: first letter).
 * Set the matching REACT_APP_* in .env (positive integer; cap 100; rebuild to apply). Default 3.
 */
function parseLimit(envValue) {
    const n = parseInt(String(envValue ?? ""), 10);
    if (Number.isFinite(n) && n > 0) {
        return Math.min(100, n);
    }
    return 3;
}

export const CROSSWORD_HINT_WORD_LIMIT = parseLimit(process.env.REACT_APP_CROSSWORD_HINT_WORD_LIMIT);

/** First-letter highlights on grid (word search / hidden message) when the lightbulb is on. */
export const GRID_HINT_WORD_LIMIT = parseLimit(process.env.REACT_APP_GRID_HINT_WORD_LIMIT);
